export const TABLE_PAGE_SIZE = 25;
export const RECORD_LIMIT = 50;
